(() => {
  function buildMessage(cart, en) {
    const lines = [en ? 'Hello! I would like an international shipping quote for:' : 'Ciao! Vorrei un preventivo per una spedizione all’estero per:'];
    for (const item of cart.items) {
      lines.push(`${item.quantity} × ${item.product_title || item.title}${item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : ''}`);
      for (const [key, value] of Object.entries(item.properties || {})) {
        if (!key.startsWith('_') && value) lines.push(`  ${key}: ${value}`);
      }
      if (item.selling_plan_allocation?.selling_plan?.name) lines.push(`  ${item.selling_plan_allocation.selling_plan.name}`);
    }
    lines.push('', en ? 'Country: ' : 'Paese: ', en ? 'City and postal code: ' : 'Città e codice postale: ');
    return lines.join('\n');
  }
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-quote-cart]');
    if (!link) return;
    event.preventDefault();
    if (link.getAttribute('aria-disabled') === 'true') return;
    const status = link.closest('[data-international-quote]').querySelector('[role="status"]');
    const en = link.dataset.language === 'en';
    const email = link.dataset.channel === 'email';
    link.setAttribute('aria-disabled', 'true');
    status.textContent = en ? 'Preparing your cart…' : 'Preparazione del carrello…';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
      const message = buildMessage(cart, en);
      let destination;
      if (email) {
        const subject = en ? 'International shipping quote — MyCastroni' : 'Preventivo spedizione estero — MyCastroni';
        destination = 'mailto:mycastroni@gmail.com?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(message.replace(/\n/g, '\r\n'));
        status.textContent = en ? 'Your email app will open. If it doesn’t, ' : 'Si aprirà la tua app email. Se non si apre, ';
        const retry = document.createElement('a');
        retry.href = destination;
        retry.textContent = en ? 'open the prepared email.' : 'apri l’email preparata.';
        status.append(retry);
      } else {
        const url = new URL(link.href);
        url.searchParams.set('text', message);
        destination = url.href;
        status.textContent = '';
      }
      window.location.assign(destination);
    } catch {
      status.textContent = en ? 'We couldn’t load your cart. Try again, or ' : 'Non riusciamo a recuperare il carrello. Riprova oppure ';
      const fallback = document.createElement('a');
      fallback.href = link.href;
      fallback.textContent = email
        ? (en ? 'open email and include your products and quantities.' : 'apri l’email e indica prodotti e quantità.')
        : (en ? 'open WhatsApp and include your products and quantities.' : 'apri WhatsApp e indica prodotti e quantità.');
      status.append(fallback);
    } finally {
      clearTimeout(timeout);
      link.removeAttribute('aria-disabled');
    }
  });
})();
